import { FileModel, AttachmentModel } from "@interfaces/index";
import { FILE_PREVIEW_EXTENSIONS } from "@utils/index";

export const isFilePreviewable = (file: FileModel | AttachmentModel) => {
  return !file.originalName
    ? false
    : FILE_PREVIEW_EXTENSIONS.includes(
        file.originalName.split(".").slice(-1)[0],
      );
};
